import { useRef, FC } from 'react'
import { ThemeProvider } from 'styled-components'
// import Fireworks from 'react-canvas-confetti/dist/presets/fireworks'
import GlobalStyles from '../styles/Global'
import { darkTheme, lightTheme } from '../styles/theme'
import { Header } from './Header'
import { Main } from './Main'
import { useAppSelector } from '../app/hooks'
import { ThemeMode } from '../typing/enums'
// import { Cart } from '../features/cart/Cart'

export const App:FC = () => {
  // const Confetti:FC = () => {
  //   return (
  //     <Fireworks
  //       autorun={{
  //         speed: 2,
  //         duration: 3000,
  //         delay: 1500,
  //       }}
  //     />
  //   )
  // }

  // for navigation
  const aboutSection = useRef<HTMLElement>(null)
  const portfolioSection = useRef<HTMLElement>(null)

  const themeMode = useAppSelector(state => state.theme.mode)

  const theme = (themeMode === ThemeMode.dark)
    ? darkTheme
    : lightTheme

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {/* <Confetti /> */}
      <Header
        aboutSection={aboutSection}
        portfolioSection={portfolioSection}
      />
      <Main
        aboutSection={aboutSection}
        portfolioSection={portfolioSection}
      />
      {/* <Cart /> */}
    </ThemeProvider>
  )
}
